import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Lock } from 'lucide-react';

import { IconBadge } from 'components/UI/IconBadge';

const CompanySuspended: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <Stack spacing={3} alignItems="center" maxWidth={500}>
        {/*
          The shared `IconBadge` — the grey circle every state screen in this app opens
          with. A padlock in the ALERT tone: access is genuinely blocked and the reader
          cannot proceed, which is the axis that earns the red (a fault or a block, versus
          a condition being explained). Unlike the scan-failure pages, this one is read by
          the BRAND's own staff, not by a customer holding an item, so there is no risk of
          a red badge being taken as a verdict on a physical good.
        */}
        <IconBadge icon={Lock} tone="alert" />

        <Stack spacing={2} alignItems="center">
          <Typography variant="h2" sx={{ fontWeight: 600 }}>
            Account Suspended
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Your company has been suspended. Please contact support to restore access.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CompanySuspended;
